<template>
    <thead>
        <CostableTableRow
            :headings="true"
            class="larger-font"
        >
            <template v-slot:select>
                <CostableTableSelectCheckbox
                    v-if="$store.getters['costable/isEditable']"
                    :value="allSelected"
                    :indeterminate="indeterminate"
                    :disabled="!hasCosts"
                    @input="selectAll"
                />
            </template>
            <template v-slot:taxRate>
                Tax Rate
            </template>
            <template v-slot:tab>
                Tab
            </template>
            <template v-slot:type>
                {{ $t('cost.type') }}
            </template>
            <template v-slot:nominalCode>
                {{ $t('cost.nominal_code') }}
            </template>
            <template v-slot:description>
                {{ $t('cost.description') }}
            </template>
            <template v-slot:supplier>
                {{ $t('cost.supplier') }}
            </template>
            <template v-slot:quantity>
                {{ $t('cost.quantity') }}
            </template>
            <template v-slot:duration>
                {{ $t('cost.duration') }}
            </template>
            <template v-slot:unitCost>
                {{ $t('cost.unit_cost') }}
            </template>
            <template v-slot:currencyCost>
                {{ $t('cost.currency_cost') }}
            </template>
            <template v-slot:unitPrice>
                {{ $t('cost.unit_price') }}
            </template>
            <template v-slot:currencyPrice>
                {{ $t('cost.currency_price') }}
            </template>
            <template v-slot:totalCost>
                {{ $t('cost.total_cost') }}
            </template>
            <template v-slot:totalPrice>
                {{ $t('cost.total_price') }}
            </template>
            <template v-slot:markup>
                {{ $t('cost.markup') }}
            </template>
            <template v-slot:margin>
                {{ $t('cost.margin') }}
            </template>
            <template v-slot:discount>
                {{ $t('cost.discount') }}
            </template>
            <template v-slot:fee>
                {{ $t('cost.fee_short') }}
            </template>
            <template v-slot:commission>
                {{ $t('cost.commission') }}
            </template>
            <template v-slot:commissionDue>
                {{ $t('cost.commission_due') }}
            </template>
            <template v-slot:totalProfit>
                {{ $t('cost.total_profit') }}
            </template>
            <template v-slot:icons>
                <i
                    v-b-tooltip.text.hover.top.d50
                    title="Notes"
                    class="fa fa-file-text"
                />
                <i
                    v-b-tooltip.text.hover.top.d50
                    title="Resources"
                    class="fa fa-cube"
                />
            </template>
            <template v-slot:user>
                {{ $t('cost.user') }}
            </template>
            <template v-slot:status>
                {{ $t('cost.status') }}
            </template>
            <template v-slot:secondaryStatus>
                {{ $t('cost.secondary_status') }}
            </template>
            <template v-slot:transactionType>
                {{ $t('cost.transaction_type') }}
            </template>
            <template v-slot:reconciled>
                <i
                    v-b-tooltip.text.hover.top.d50
                    title="Reconciled"
                    class="fa fa-check"
                />
            </template>
            <template v-slot:actions>
                <button
                    class="btn btn-xs btn-default"
                    type="button"
                    @click="showSettings"
                >
                    <i
                        v-b-tooltip.text.hover.top.d50
                        title="Settings"
                        class="fa fa-cog"
                    />
                </button>
            </template>
        </CostableTableRow>
    </thead>
</template>

<script>
import CostableTableRow from '@/modules/costable/_components/CostableTableRow';
import CostableTableSelectCheckbox from './CostableTableSelectCheckbox';

export default {

    components: {
        CostableTableRow,
        CostableTableSelectCheckbox,
    },

    computed: {
        hasCosts() {
            return this.costCount > 0;
        },
        selectedCount() {
            return this.$store.getters['costable/selectCostCount'];
        },
        costCount() {
            return this.$store.getters['costable/costCount'];
        },
        allSelected() {
            return this.selectedCount === this.costCount
                && this.hasCosts;
        },
        indeterminate() {
            return this.selectedCount > 0
                && this.selectedCount < this.costCount;
        },
    },

    methods: {
        selectAll(value) {
            this.$store.dispatch('costable/selectAll', value);
        },
        showSettings() {
            this.$eventBus.$emit(this.$events.openColumnSettingsModel);
        },
    },

};
</script>

<style lang="scss" scoped>
th {
    font-size: 14px;
    font-weight: 600;
}
.notes-resources-icons {
    width: 3rem;
}
.larger-font {
   font-size: 14px;
}
.bolder-font {
    font-weight: 600;
}
</style>
